import React from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { StyledButton } from '../../styles/StyledButtons';
import { CaptureLogsOption } from './CaptureLogsOption';

interface ImpersonateActionsProps {
  isMobile: boolean;
  busy: 'browser' | 'app' | null;
  captureLogsAvailable: boolean;
  captureLogs: boolean;
  onCaptureLogsChange: (captureLogs: boolean) => void;
  onOpenInApp: () => void;
  onOpenInBrowser: () => void;
}

const spinnerIf = (show: boolean) => (show ? <CircularProgress size={16} /> : undefined);

export function ImpersonateActions({
  isMobile,
  busy,
  captureLogsAvailable,
  captureLogs,
  onCaptureLogsChange,
  onOpenInApp,
  onOpenInBrowser,
}: ImpersonateActionsProps) {
  const disabled = busy != null;

  return (
    <Box display="flex" flexDirection="column" gap={2} pt={1}>
      <Typography variant="body2" color="text.secondary">
        {isMobile
          ? 'Open this contact’s session in the Fides app on this phone, or continue in the browser.'
          : 'Continue in the browser, or hand the session off to the Fides mobile app.'}
      </Typography>

      {captureLogsAvailable && (
        <CaptureLogsOption
          checked={captureLogs}
          disabled={disabled}
          onChange={onCaptureLogsChange}
        />
      )}

      {isMobile ? (
        <>
          <StyledButton
            variant="contained"
            onClick={onOpenInApp}
            disabled={disabled}
            startIcon={spinnerIf(busy === 'app')}
          >
            Open in app
          </StyledButton>
          <Button variant="text" onClick={onOpenInBrowser} disabled={disabled}>
            Open in browser instead
          </Button>
        </>
      ) : (
        <Box display="flex" gap={2}>
          <StyledButton
            variant="outlined"
            onClick={onOpenInBrowser}
            disabled={disabled}
            startIcon={spinnerIf(busy === 'browser')}
          >
            Open in browser
          </StyledButton>
          <StyledButton
            variant="contained"
            onClick={onOpenInApp}
            disabled={disabled}
            startIcon={spinnerIf(busy === 'app')}
          >
            Open in app
          </StyledButton>
        </Box>
      )}
    </Box>
  );
}

export default ImpersonateActions;
